import { ReactNode } from "react";

import messages from "../messages/ja.json";
import { FeVersion } from "./fe-version";

import "../styles/auth-flow.css";
import "../styles/secret-question.css";

interface Props {
  username?: string;
  title?: string;
  // "顔認証に戻る" link in the header. Omitted → the link is not rendered.
  onBackToFace?: () => void;
  backDisabled?: boolean;
  children: ReactNode;
  footer?: ReactNode;
}

// Full-page shell for the secret-question (秘密の質問) screen: user info + centred title +
// back-to-face link, a gradient body holding the card, and a white action footer. Its own
// .secret-question-* namespace keeps it independent from the face shells.
export function SecretQuestionShell({
  username,
  title = messages.secretQuestions.verifyTitle,
  onBackToFace,
  backDisabled,
  children,
  footer,
}: Props) {
  return (
    <main className="secret-question-shell">
      {/* space-between over three cells: the empty spacers keep the title centred when there
          is no user info or no back link to balance it. */}
      <header className="secret-question-header">
        {username ? (
          <div className="secret-question-user">
            <span className="secret-question-user-label">{messages.auth.userLabel}</span>
            {/* title: the value is ellipsised rather than wrapped, so keep the full
                address reachable on hover. */}
            <span className="secret-question-user-value" title={username}>
              {username}
            </span>
          </div>
        ) : (
          <span className="secret-question-head-spacer" aria-hidden="true" />
        )}

        <h1 className="secret-question-title">{title}</h1>

        {/* Right cell: back link (when present) then the version, so the version keeps the
            top-right corner it has on every other screen. The wrapper always renders so it
            keeps balancing the left cell around the title. */}
        <div className="secret-question-head-right">
          {onBackToFace ? (
            <button
              type="button"
              className="secret-question-back"
              onClick={onBackToFace}
              disabled={backDisabled}
            >
              {messages.secretQuestions.backToFace}
            </button>
          ) : null}
          <FeVersion />
        </div>
      </header>

      <div className="secret-question-body">{children}</div>

      {footer ? <footer className="secret-question-footer">{footer}</footer> : null}
    </main>
  );
}
